import { getAuthToken, clearSession } from '../auth/session.js';

let installed = false;

function isApiUrl(url: string): boolean {
  try {
    return new URL(url, window.location.origin).pathname.startsWith('/api/');
  } catch {
    return false;
  }
}

/**
 * Ajoute `Authorization: Bearer <token>` à tout appel `fetch()` vers `/api/...`.
 * Un seul point d'interception, plutôt que de retoucher chaque module d'API.
 */
export function installAuthFetchInterceptor(): void {
  if (installed || typeof window === 'undefined') return;
  installed = true;
  const originalFetch = window.fetch.bind(window);
  window.fetch = (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    const token = getAuthToken();
    const url = typeof input === 'string' ? input : input.toString();
    if (!token || !isApiUrl(url)) return originalFetch(input, init);
    const headers = new Headers(
      init?.headers ?? (input instanceof Request ? input.headers : undefined)
    );
    headers.set('Authorization', `Bearer ${token}`);
    return originalFetch(input, { ...init, headers }).then((res) => {
      // Session expirée/révoquée côté serveur : on nettoie et renvoie vers la connexion
      // plutôt que de laisser la page courante échouer silencieusement en boucle.
      if (res.status === 401 && window.location.hash !== '#connexion') {
        clearSession();
        window.location.hash = 'connexion';
      }
      return res;
    });
  };
}
